"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("./form");
exports.FormReduxComponent = form_1.FormReduxComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9yZWR1eC9zYW1wbGUvcGFydHMvZm9ybS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtCQUE0QztBQUFuQyxvQ0FBQSxrQkFBa0IsQ0FBQSJ9